import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPaginationModule } from 'ngx-pagination';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { CommonComponentsModule } from '../../common/common.module';
import { BatchManagementComponent } from './management/batch-management.component';
import { TemplateConfigurationComponent } from './template-configuration/template-configuration.component';
import { BatchManagementModalComponent } from './management/batch-management-modal/batch-management-modal.component';
import { BatchTemplateModalComponent } from './template-configuration/batch-template-modal/batch-template-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxFilesizeModule } from 'ngx-filesize';


@NgModule({
  declarations: [
    BatchManagementComponent,
    TemplateConfigurationComponent,
    BatchManagementModalComponent,
    BatchTemplateModalComponent
  ],
  entryComponents: [
    BatchManagementComponent,
    TemplateConfigurationComponent,
    BatchManagementModalComponent,
    BatchTemplateModalComponent
  ],
  imports: [
    CommonComponentsModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    NgxPaginationModule,
    DragDropModule,
    NgxFilesizeModule
  ],
  exports: [

  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})

export class BatchModule { }
